import React from 'react';
import { CheckCircle } from 'lucide-react';

const PaymentSuccess = () => {
      const handleBackToHome = () => {
            window.location.href = '/';
      };

      return (
            <div className="flex justify-center items-center h-screen bg-gray-100">
                  <div className="w-full max-w-md p-6 text-center bg-white shadow-lg rounded-2xl">
                        <CheckCircle className="text-amber-500 w-16 h-16 mx-auto mb-4" />
                        <h1 className="text-2xl font-bold mb-2">Payment Successful!</h1>
                        <p className="text-gray-600 mb-4">
                              Your transaction has been successfully completed. Thank you for your purchase!
                        </p>
                        <button
                              className="w-full bg-amber-500 text-white py-2 rounded-md hover:bg-amber-600"
                              onClick={handleBackToHome}
                        >
                              Back to Home
                        </button>
                  </div>
            </div>
      );
};

export default PaymentSuccess;
